import { RefObject } from "react";

import { PDF_OUTPUT_MARGIN } from "../../constants";

interface Props {
  contentRef: RefObject<HTMLDivElement>;
  documentTitle: string;
}

const useImplementationGuidePDFDownload = (props: Props) => {
  const { contentRef, documentTitle } = props;
  const generateAndDownloadPDF = async (html: string, pageHeight: number) => {
    // Dynamically import html2pdf because it uses native web apis which are not
    // available when Next.js prerenders the page on the server.
    // See https://stackoverflow.com/a/66100185
    const { default: html2pdf } = await import("html2pdf.js" as string);

    html2pdf()
      .from(html)
      .set({
        filename: documentTitle,
        pagebreak: {
          mode: ["css"],
        },
        jsPDF: {
          unit: "px",
          format: [800, pageHeight],
        },
      })
      .save();
  };

  const downloadPDF = async () => {
    if (contentRef.current) {
      const html = contentRef.current.outerHTML;
      const pageHeight = contentRef.current.scrollHeight;

      // This adds padding to the bottom of the PDF and prevents an unnecessary page
      // break from occuring when the content height surpasses the page margin.
      const pageHeightWithPadding = pageHeight + PDF_OUTPUT_MARGIN * 2;

      await generateAndDownloadPDF(html, pageHeightWithPadding);
    }
  };

  return downloadPDF;
};

export default useImplementationGuidePDFDownload;
